import moment from "moment";
import { CustomNotification } from "../../../../../v2-components/Notification";
import { Notification } from "../../../../../v2-components/Notification/constant";

export const isTodayOrFuture = (dateStr) => {
  const inputDate = moment(dateStr, 'DD/MM/YY').startOf('day'); 

  const today = moment().startOf('day');

  if (inputDate.isBefore(today)) {
    CustomNotification({
      type: Notification.type.error,
      message: Notification.message.error,
      description: 'La fecha seleccionada no puede ser anterior al día de hoy.',
    });
    return false; 
  }

  return true; 
};
